import { render } from "./CartListCard.vue?vue&type=template&id=dd8d1ce4&scoped=true"
import script from "./CartListCard.vue?vue&type=script&lang=js"
export * from "./CartListCard.vue?vue&type=script&lang=js"

import "./CartListCard.vue?vue&type=style&index=0&id=dd8d1ce4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd8d1ce4"]])

export default __exports__